
import Swiper from 'vux/src/components/swiper/swiper.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'

import { host } from '../src/api/base'

export default {
name: 'App',
components: {
Swiper,
GroupTitle
},
created () {
console.log(host)
this.getBanner()
this.getName()
},
methods: {
menuShow () {
document.getElementById('menu').style.display = 'block'
document.getElementById('show').style.display = 'block'
},
menuClose () {
document.getElementById('menu').style.display = 'none'
document.getElementById('show').style.display = 'none'
},
jump (name) {
document.getElementById('menu').style.display = 'none'
document.getElementById('show').style.display = 'none'
this.$router.push({ name: name })
},
getBanner () {
this.$http.post(host + 'banner').then(({data}) => {
this.demo03_list = data.data
})
},
getName () {
this.$http.post(host + 'config/PT_NAME').then(({data}) => {
this.name = data.data.content
})
}
},
data () {
return {
demo03_list: [],
swiperItemIndex: 1,
name: '盐亭县卫生健康局'
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue